import{AssistChip as s}from"./assist-chip.js";/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */class e extends s{}export{e as SuggestionChip};
